import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Gold Price Tracker</h3>
            <p>Your trusted source for real-time gold prices and calculations.</p>
            <div className="seo-content" style={{ display: 'none' }}>
              <h1>Live Gold Prices & Calculator</h1>
              <p>Track real-time gold prices in multiple currencies including USD, EUR, GBP, and INR. Get accurate gold price per gram and per troy ounce calculations. Our gold calculator helps you determine the value of your gold jewelry and investments based on current market rates.</p>
              <h2>Gold Price Trends & Market Analysis</h2>
              <p>Stay updated with the latest gold price trends and market analysis. Monitor gold rates in major currencies and understand the factors affecting gold prices. Our platform provides comprehensive gold price tracking and historical data analysis.</p>
              <h3>Gold Investment & Trading</h3>
              <p>Make informed decisions about gold investments with our real-time price tracking and calculator tools. Whether you're buying gold jewelry, investing in gold bars, or trading gold futures, our platform helps you stay ahead of market trends.</p>
              <h4>Gold Purity & Karat Calculator</h4>
              <p>Calculate the value of your gold based on purity levels (24K, 22K, 18K, 14K) and weight. Our gold calculator considers current market rates and purity factors to give you accurate valuations for your gold assets.</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Gold Price Tracker. All rights reserved.</p>
          <meta name="description" content="Track live gold prices, calculate gold value, and stay updated with gold market trends. Real-time gold price calculator for multiple currencies and purity levels." />
          <meta name="keywords" content="gold price, gold calculator, live gold rates, gold price today, gold price per gram, gold price per ounce, gold investment, gold trading, gold market, gold purity calculator, 24k gold price, 22k gold price, gold price in USD, gold price in EUR, gold price in GBP, gold price in INR" />
          <meta name="robots" content="index, follow" />
          <meta property="og:title" content="Gold Price Tracker - Live Gold Prices & Calculator" />
          <meta property="og:description" content="Track real-time gold prices and calculate gold value in multiple currencies. Get accurate gold price per gram and per troy ounce calculations." />
          <meta property="og:type" content="website" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Gold Price Tracker - Live Gold Prices & Calculator" />
          <meta name="twitter:description" content="Track real-time gold prices and calculate gold value in multiple currencies. Get accurate gold price per gram and per troy ounce calculations." />
        </div>
      </div>
    </footer>
  );
};

export default Footer; 